import React from 'react'
import { Avatar } from '@driftt/tide-core'

import './style.styl'


export const AvatarCompat = props => (
  <div className="user-avatar-compat">
    <Avatar {...props} />
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/AvatarCompat/index.js